import classes from "./Header.module.css";
import sponsor from "./../../../SMARTCITY/assets/images/sponsor.png";
import city from "./../../../SMARTCITY/assets/images/city.png";
import cityEn from "./../../../TEMPLATE/assets/images/smartiscity_logo.png";
import { useHistory, useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import LanguageContext from "./../../hooks/language-context";
import cookies from "js-cookie";
import i18next from "i18next";
import styled from "styled-components";
import * as Icon from "../../components/Map/smartiscity/Icons";

const Header = () => {
  const history = useHistory();
  const languageCtx = useContext(LanguageContext);
  const { search } = useLocation();
  const typeIdFromURL = new URLSearchParams(search).get("typeId");
  const currentLanguageCode = cookies.get("i18next") || "el";

  console.log(languageCtx);
  const redirectHandler = () =>
    history.location.pathname !== "/" && history.push("/");

  return (
    <div
      style={{
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        zIndex: "5",
      }}
    >
      <div
        style={{
          height: "40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 50px",
          boxShadow: "0px 0px 12px 0px rgb(0 0 0 / 12%)",
          backgroundColor: "white",
          zIndex: "5",
        }}
      >
        <div
          style={{
            maxHeight: "40px",
            aspectRatio: "353 / 29",
            position: "relative",
          }}
        >
          <img
            // src={languageCtx.languageCode === "en" ? cityEn : cityEn}
            src={cityEn}
            alt="smartIsCity logo"
            width="100%"
            onClick={redirectHandler}
          />
        </div>
        {/* ============== */}
        {typeIdFromURL === "122" && (
          <NewRouteButton
            type="primary"
            onClick={() => {
              localStorage.setItem("redirectPath", window.location.pathname);
              window.location.href = `https://amea-ampel-cms.dotsoft.gr/oauth/authorize?client_id=a0qEic7h0fWT3034AOz8q57IfUXKVBPw&redirect_uri=http://localhost:3000/map?typeId=122&scope=citizen&response_type=code`;
            }}
          >
            <img src={Icon.login} />
            Σύνδεση
          </NewRouteButton>
        )}

        {/* <div className={classes.sponsor_logo__container}>
        <div className={classes.changeLanguage__Wrapper}>
          <span
            className={
              languageCtx.languageCode === "el" ? classes.activeLanguage : null
            }
            onClick={() => {
              if (currentLanguageCode === "el") return;
              i18next
                .changeLanguage("el")
                .catch((error) => console.warn(error));
              languageCtx.languageCodeHandler("el");
            }}
          >
            EL
          </span>{" "}
          |{" "}
          <span
            className={
              languageCtx.languageCode === "en" ? classes.activeLanguage : null
            }
            onClick={() => {
              if (currentLanguageCode === "en") return;
              i18next
                .changeLanguage("en")
                .catch((error) => console.warn(error));
              languageCtx.languageCodeHandler("en");
            }}
          >
            EN
          </span>
        </div>
        <img src={sponsor} alt="sponsor logo" className={classes.logo_normal} />
      </div> */}
      </div>
    </div>
  );
};

export default Header;

const NewRouteButton = styled.button`
  border-radius: 12px;
  background-color: #27aae1;
  width: fit-content;
  height: fit-content;
  padding: 10px 16px;
  color: #000;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &:hover {
    background-color: #4bc7fa;
  }
  transition: all 0.6s ease;
`;
